<template>
  <div id="situation">
    <ProgressionBar></ProgressionBar>
    <div class="page">
      <div class="title" v-if="isFirstStep" :class="$mq">
        <h1>{{ $t('Situation.title') }}</h1>
        <h2>{{ $t('Situation.subtitle') }}</h2>
      </div>
      <transition enter-active-class="animated fadeInUp">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import ProgressionBar from "@/components/ProgressionBar.vue";

export default {
  computed: {
    isFirstStep() {
      return this.$route.name === 'PersonalDetails';
    }
  },
  components: {
    ProgressionBar,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Situation.vue